import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useFocusEndTVMutation } from "./__generated__/useFocusEndTVMutation.graphql";

export function useFocusEnd(storecastId: string) {
  const [mutation] = useMutation<useFocusEndTVMutation>(graphql`
    mutation useFocusEndTVMutation(
      $storecastId: ID!
      $subject: StorecastFocusSubjectNewInput
    ) {
      dashboard(dashboardId: $storecastId) {
        setNewFocus(subject: $subject) {
          subject {
            nodeId
            detailItemId
          }
        }
      }
    }
  `);

  const focusEnd = useCallback(() => {
    mutation({
      updater: (store) => {
        const storecast = store.get(storecastId);
        if (!storecast) return;
        storecast.setValue(null, "focusedNodeId");
        storecast.setValue(null, "focusedDetailItemId");
      },
      variables: {
        storecastId,
        subject: null,
      },
    });
  }, [mutation, storecastId]);

  return focusEnd;
}
